export default __webpack_public_path__ + "static/media/18.2ff4b3b0.png";